/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on Sep 12, 2026 by hoarfroster
 *
 */

let lockCount = 0;
let previousOverflow = '';

/** Prevent body scrolling while any modal layer is open (re-entrant). */
export function acquireScrollLock(): void {
    if (typeof document === 'undefined') return;
    if (lockCount++ === 0) {
        previousOverflow = document.body.style.overflow || '';
        document.body.style.overflow = 'hidden';
    }
}

/** Release one scroll-lock acquisition; restores body overflow at zero. */
export function releaseScrollLock(): void {
    if (typeof document === 'undefined') return;
    if (lockCount > 0 && --lockCount === 0) {
        document.body.style.overflow = previousOverflow;
        previousOverflow = '';
    }
}
